import { Pipe } from '@angular/core';
var IsLessThanPipe = (function () {
    function IsLessThanPipe() {
    }
    IsLessThanPipe.prototype.transform = function (input, other) {
        return input < other;
    };
    IsLessThanPipe.decorators = [
        { type: Pipe, args: [{ name: 'isLessThan' },] },
    ];
    /** @nocollapse */
    IsLessThanPipe.ctorParameters = function () { return []; };
    return IsLessThanPipe;
}());
export { IsLessThanPipe };
//# sourceMappingURL=is-less-than.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-less-than.js
// module id = 248
// module chunks = 4